export { FitScale as default } from './FitScale'
